import dayjs, { Dayjs } from 'dayjs'

export type SinceDateField = 'customLeadSince' | 'customCustomerSince'

export type SinceDateOverride = {
  currentDate: string | null
  standardDate: string | null
  fieldName: SinceDateField
  type: 'lead' | 'customer'
}

export const SINCE_DATE_STORE_FORMAT = 'MMM D, YYYY'

export const parseSinceDate = (value: string | null | undefined): Dayjs | null =>
  value ? dayjs(value) : null

export const formatSinceDateValue = (date: Dayjs | null): string | null =>
  date ? date.format(SINCE_DATE_STORE_FORMAT) : null

export const shouldShowReset = (pickedDate: Dayjs | null, standardDate: string | null | undefined): boolean => {
  const picked = formatSinceDateValue(pickedDate)
  const standard = standardDate ? dayjs(standardDate).format(SINCE_DATE_STORE_FORMAT) : null
  return picked !== standard
}
